import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './api/commAxios'
import 'vant/lib/index.css'
import "./style/common.less"
import 'amfe-flexible';
import store from './store/'

Vue.prototype.$axios = axios
Vue.config.productionTip = false
import {
    Button,
    Uploader,
    PullRefresh,
    Collapse,
    CollapseItem,
    ImagePreview,
    Skeleton,
    Icon,
    Field,
    Cell,
    CellGroup,
    NumberKeyboard,
    ActionSheet,
    Row,
    Col,
    Radio,
    RadioGroup,
    Picker,
    Popup,
    Toast,
    Tab,
    Tabs,
    Checkbox,
    CheckboxGroup,
    Tabbar,
    TabbarItem,
    Search,
    DatetimePicker,
    SwipeCell,
    Notify,
    List,
    IndexBar,
    IndexAnchor,
    Dialog,
    Image,
    Loading,
    DropdownMenu,
    DropdownItem,
    Popover,
    Tag
} from 'vant';

let comps = [
    Button,
    Uploader,
    PullRefresh,
    Collapse,
    CollapseItem,
    ImagePreview,
    Skeleton,
    Icon,
    Field,
    Cell,
    CellGroup,
    NumberKeyboard,
    ActionSheet,
    Row,
    Col,
    Radio,
    RadioGroup,
    Picker,
    Popup,
    Toast,
    Tab,
    Tabs,
    Checkbox,
    CheckboxGroup,
    Tabbar,
    TabbarItem,
    Search,
    DatetimePicker,
    SwipeCell,
    Notify,
    List,
    IndexBar,
    IndexAnchor,
    Dialog,
    Image,
    Loading,
    DropdownMenu,
    DropdownItem,
    Popover,
    Tag
]
for (let comp of comps) {
    Vue.use(comp)
}

import * as filters from './filters' // global filters
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
//区分测试环境和线上环境的接口地址
// axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'http://172.16.15.18:80/promotion' : 'http://172.16.15.18:80/';
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')

// 为嵌入在线服务小程序新增——路由拦截，修改浏览器顶部标题
router.afterEach((to, from, next) => {
    setTimeout(() => {
        console.log('-------router to：', to);
        // 补充担保与变更担保共用同一个页面，判断修改不同的名称
        if (to.path === '/previewBCDB') {
            // 变更担保
            if (to.query.mode === '1') {
                window.document.title = '担保服务-补充担保';
            } else {
                window.document.title = '担保服务-变更担保';
            }
            return;
        }
        window.document.title = to.meta.title;
    }, 0)
})



